import BaseApi from './BaseApi'

class AdministratorsApi extends BaseApi {
  get administratorsUrl () {
    return 'administrators'
  }
  login (emailAddress, password) {
    return this.postJson(`${this.administratorsUrl}/login`, {
      emailAddress: emailAddress,
      password: password
    })
      .then((response) => response.json())
      .catch((err) => {
        if (err && err.response) {
          const error = new Error('Login failed')
          error.status = err.response.status
          error.payload = null
          throw error
        }
        throw err
      })
  }

  updatePassword (resetToken, newPassword, confirmedPassword) {
    return this.putJson(`${this.administratorsUrl}/password`, {
      resetToken: resetToken,
      newPassword: newPassword,
      confirmedPassword: confirmedPassword
    })
  }

  resetPassword (emailAddress) {
    return this.postJson(`${this.administratorsUrl}/reset-password`, {
      emailAddress: emailAddress
    })
  }

  getAdministrators () {
    return this.getJson(`${this.administratorsUrl}/administrators`)
  }

  postAdministrator (administrator) {
    return this.postJson(`${this.administratorsUrl}/administrator/add`, administrator)
  }

  setAdministratorActive (administrator) {
    return this.putJson(`${this.administratorsUrl}/administrator`, administrator)
  }
}
export default AdministratorsApi
